import Vue from 'vue'
import Router from 'vue-router'
import store from "../store/index"
import { Toast } from 'vant'

import Layout from '@/views/layout/Layout'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/404',
      name: 'NotFound',
      component: () => import('@/views/404'),
      hidden: true
    },
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/version',
      name: 'Version',
      component: () => import('@/views/version'),
      meta: {title: "版本记录"}
    },
    {
      path: '/agreement',
      name: 'Agreement',
      component: () => import('@/views/agreementBox/agreement'),
      meta: {title: "用户协议及隐私政策"}
    },
    {
      path: '/agreementUser',
      name: 'AgreementUser',
      component: () => import('@/views/agreementBox/agreementUser'),
      meta: {title: "亲小禾用户协议"}
    },
    {
      path: '/agreementPrivacy',
      name: 'AgreementPrivacy',
      component: () => import('@/views/agreementBox/agreementPrivacy'),
      meta: {title: "亲小禾隐私协议"}
    },
    {
      path: '/agreementChildrenPrivacy',
      name: 'AgreementChildrenPrivacy',
      component: () => import('@/views/agreementBox/agreementChildrenPrivacy'),
      meta: {title: "亲小禾儿童隐私协议"}
    },
    {
      path: '/BrandBin',
      name: 'BrandBin',
      component: () => import('@/views/BrandBin'),
      meta: {title: "内部测试"}
    },
    {
      path: '/cloudCall',
      name: 'InternetTelephone',
      component: () => import('@/views/internetTelephone'),
      meta: {title: "网络电话"}
    },
    {
      path: '/index',
      name: 'Index',
      component: () => import('@/views/index'),
      meta: {title: "首页"}
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login'),
      meta: {title: "登录"}
    },
    {
      path: '/activity',
      component: Layout,
      redirect: "/activity/payActivity",
      children: [
        {
          path: 'payActivity',
          name: 'PayActivity',
          meta: {title: '校园阅读活动'},
          component: () => import('@/views/activity/payActivity')
        }
      ]
    },
    {
      path: '/download',
      name: 'Download',
      component: () => import('@/views/download/index'),
      meta: {title: "亲小禾AI阅读器"}
    },
    {
      path: '/QrLogin',
      name: 'QrLogin',
      component: () => import('@/views/QrLogin'),
      meta: {title: "二维码登录", needLogin: false}
    },
    {
      path: '/courseList',
      name: 'CourseList',
      component: () => import('@/views/course/courseList'),
      meta: {title: "绘本课程", needLogin: true, keepAlive: true}
    },
    {
      path: '/courseIntroduce',
      name: 'CourseIntroduce',
      component: () => import('@/views/course/courseIntroduce'),
      meta: {title: "课程介绍", needLogin: true}
    },
    {
      path: '/coursePPT',
      name: 'CoursePPT',
      component: () => import('@/views/course/coursePPT'),
      meta: {title: "课件演示", needLogin: true}
    },
    {
      path: '/demoCoursePPT',
      name: 'DemoCoursePPT',
      component: () => import('@/views/course/demoCoursePPT'),
      meta: {title: "课件演示"}
    },
    {
      path: '/borrowedRecord',
      name: 'BorrowedRecord',
      component: () => import('@/views/borrowManage/borrowedRecord'),
      meta: {title: "借阅记录"}
    },
    { path: '*', redirect: '/404'}
  ]
})


router.beforeEach((to, from, next) => {
  let {title, needLogin} = to.meta
  let isLogin = store.getters.isLogin
  document.title = title || '亲小禾'
  if (needLogin && !isLogin) {
    Toast.fail('登录已过期')
    setTimeout(() => {
      store.dispatch('FedLogOut').then(() => {
        next({
          path: "/QrLogin"
        })
      })
    }, 3000)
  } else {
    next()
  }
})

export default router
